import LxcError from "~/core/models/LxcError.class";
import type { Pki } from "~/modules/pki/models/Pki.interface";
import pkiService from "~/modules/pki/services/pki.service";

export function useFetchPki() {
  const service = pkiService.getPki.bind(pkiService);

  const isLoading: Ref<boolean> = ref(false);
  const result: Ref<Pki | undefined> = ref();
  const error: Ref<LxcError | undefined> = ref();

  async function fetchPki(alias: string) {
    isLoading.value = true;
    error.value = undefined;
    result.value = undefined;

    const response = await service(alias);

    if (LxcError.check(response)) {
      error.value = response;
    } else {
      result.value = response;
    }

    isLoading.value = false;
  }

  return {
    fetchPki,
    isLoading,
    result,
    error,
  };
}
